import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';

// The phone page for "Send from phone" (在留カード check) is opened from a
// QR code by a phone that has never signed in: it must not go through
// the app's login. It loads on its own, outside the app shell.
const PhoneUpload = lazy(() => import('./v2/phone/PhoneUpload'));
const isPhonePage = window.location.pathname.startsWith('/m/card-check/');

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found in index.html');

createRoot(rootEl).render(
  <StrictMode>
    {isPhonePage ? (
      <Suspense fallback={null}>
        <PhoneUpload />
      </Suspense>
    ) : (
      <App />
    )}
  </StrictMode>
);
